import { useCookies } from '@/hooks/use-cookies';
import { Cookie } from '@/types/storage';

const useBasketId = () => useCookies(Cookie.BASKET_ID);

export default useBasketId;
